import api from "@/services/api"

class AlertService {

    getAlertList() {
        return api.post('/alerts')
    }

    countUnreadAlert() {
        return api.post('/alerts/count-unread')
    }

    saveAlert(data) {
        return api.post('/alerts/save', data)
    }

    makeReaded(alertId) {
        return api.post('/alerts/make-readed/' + alertId)
    }

    makeReadedAllAlert() {
        return api.post('/alerts/make-readed-all')
    }

    showAlert(id) {
        return api.post('/alerts/show/' + id)
    }

    deleteAlert(id) {
        return api.post('/alerts/delete/' + id)
    }

    receivedAlerts(data) {
        let buildedUri = `${data.page}&perPage=${data.perPage}`

        if (typeof data.state !== "undefined") {
            buildedUri += '&state=' + data.state
        }
        return api.get('/alerts/received-alerts?page=' + buildedUri)
    }

    getLastAlert() {
        //cron for force alerts
        return api.get('/alerts/force-alerts');
    }

    getAlertTypes() {
        return api.post('/alerts/alert-types');
    }
}

export default new AlertService();